import { Inject, Injectable } from '@angular/core';

@Injectable()
export class CookiesService {
    constructor(@Inject('BASE_URL') private baseUrl: string) {}

    public getCookie(name: string) {
        let ca: Array<string> = document.cookie.split(';');
        let caLen: number = ca.length;
        let cookieName = `${name}=`;
        let c: string;

        for (let i: number = 0; i < caLen; i += 1) {
            c = ca[i].replace(/^\s+/g, '');
            if (c.indexOf(cookieName) == 0) {
                return c.substring(cookieName.length, c.length);
            }
        }
        return '';
    }

    public deleteCookie(name: string) {
        this.setCookie(encodeURIComponent(name), encodeURIComponent(''), -1);
    }

    public setCookie(name: string, value: string, expireDays: number, path: string = '') {
        let d = new Date();
        d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
        let expires = `expires=${d.toUTCString()}`;
        let cpath = path ? `path=${path}` : 'Path=/';
        const match = this.baseUrl.match(/^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:/\n?=]+)/im);
        const domain = 'domain=' + (match ? match[1] : '');
        document.cookie = `${name}=${value}; ${expires}; ${cpath}; ${domain}`;
    }

    getHeaderSafeValue(headerValue: string): string {
        if (!headerValue) {
            return '';
        }

        const rawValue = headerValue.replace(/\r/g, '').replace(/\n/g, '');
        const utf8Bytes = new TextEncoder().encode(rawValue);
        const base64Value = btoa(String.fromCharCode(...utf8Bytes));

        return base64Value;
    }

    getOriginalValueFromHeader(encodedHeaderValue: string): string | null {
        if (!encodedHeaderValue || encodedHeaderValue.trim() === '') {
            return null;
        }

        try {
            const binaryString = atob(encodedHeaderValue);
            const bytes = Uint8Array.from(binaryString, char => char.charCodeAt(0));
            const decodedValue = new TextDecoder().decode(bytes);
            return decodedValue;
        } catch (e) {
            return null; // Invalid Base64
        }
    }
}
